import { render, staticRenderFns } from "./Pos_inventory_add.vue?vue&type=template&id=147165aa&scoped=true&"
import script from "./Pos_inventory_add.vue?vue&type=script&lang=js&"
export * from "./Pos_inventory_add.vue?vue&type=script&lang=js&"
import style0 from "./Pos_inventory_add.vue?vue&type=style&index=0&id=147165aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147165aa",
  null
  
)

export default component.exports